import * as ActionTypes from '../ActionTypes';

export const GetEmployeeClearanceAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CLEARANCE_GET_REQUEST,
  params,
});

export const AddEmployeeClearanceAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CLEARANCE_ADD_REQUEST,
  params,
});

export const UpdateEmployeeClearanceAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_REQUEST,
  params,
});

export const DeleteEmployeeClearanceAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CLEARANCE_DELETE_REQUEST,
  params,
});
